<template>
  <div class="cart">
    <div style="padding-bottom:106px">
      <div class="navbar">
        <van-nav-bar
          title="购物车"
          :right-text="navtext"
          :left-arrow = false
          :fixed="true"
          @click-right="onClickEdit"
        />
      </div>
      <!-- cart list -->
      <div class="cart-list">
        <div class="list-wrap" v-for="(item,index) in cartList" :key="index">
          <!-- 复选框 -->
          <van-checkbox
            v-model="item.checked"
            checked-color="#ff9900"
            class="checkbox"
            @change="changeCheck(item)"
          ></van-checkbox>
          <div
            class="content"
            @click="$router.push({name:'productDetails',query:{productId:item.stockId}})"
          >
            <!-- 图片 -->
            <div class="product-img">
              <img
                :src="item.imgAddress"
                alt
              />
            </div>
            <!-- 品牌 -->
            <div class="product-wrap">
              <p class="brand">{{item.model}}</p>
              <p>品牌：{{item.brand}}</p>
              <p>封装规格：{{item.pack}}</p>
              <p>库存：{{item.inventory}}</p>
            </div>
          </div>
          <!-- 价格 -->
          <p class="price">￥{{item.totalAmount}}</p>
          <!-- 数量 -->
          <div class="product-num">
            <van-stepper
              integer
              v-model="item.qty"
              input-width="40px"
              button-size="32px"
              :min="item.moq"
              @blur="changeNum(item,index)"
              @plus="changeNum(item,index)"
              @minus="changeNum(item,index)"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 提交订单 -->
    <div class="footer" v-if="!showDelete">
      <van-submit-bar :price="totalPrice" button-text="去结算" @submit="settlement">
        <van-checkbox v-model="isCheckedAll" checked-color="#ff9900" @click="allCheckChange">全选</van-checkbox>
      </van-submit-bar>
    </div>
    <!-- 删除 -->
    <div class="delete-wrap" v-if="showDelete">
      <van-checkbox
        v-model="isCheckedAll"
        checked-color="#ff9900"
        style="font-size='20px'"
        @click="allCheckChange"
      >全选</van-checkbox>
      <button @click="deleteProduct">删除</button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { CartNum, shopCartSettle } from "../request/api";
export default {
  name: "cart",
  data() {
    return {
      isCheckedAll: false,
      showDelete: false,
      navtext: "编辑",
      chooseList: [], //选中的商品
      total: 0 //总价格
    };
  },
  created() {
    //获取列表
    this.$store.dispatch("getCartList");
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = false;
    next();
  },
  methods: {
    onClickEdit() {
      this.navtext = this.navtext == "编辑" ? "完成" : "编辑";
      this.showDelete = this.navtext == "编辑" ? false : true;
      this.cartList.forEach(el => {
        el.checked = false;
      });
    },

    //删除
    deleteProduct() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否删除所选商品"
        })
        .then(() => {
          let arr = [];
          this.cartList.forEach(el => {
            if (el.checked) {
              arr.push(el.id);
            }
          });
          this.$store.dispatch("deleteCart", arr);
        })
        .catch(() => {
          // on cancel
        });
    },

    //结算
    settlement() {
      let ids = [];
      if (this.chooseList.length > 0) {
        this.chooseList.forEach(el => {
          ids.push(el.id);
        });
        this.$router.push({
          name: "payment"
        });
        sessionStorage.setItem("shopId", JSON.stringify(ids));
        sessionStorage.removeItem('invoice')
      } else {
        this.$toast({
          message: "请选择要结算的商品",
          duration: 1000
        });
      }
    },

    //改变数量
    changeNum(item, index) {
      CartNum(item.id, item).then(res => {
        this.cartList[index].totalAmount = res.data;
      });
    },

    //单选
    changeCheck(item) {
      let arr = [];
      this.cartList.forEach(el => {
        if (el.checked) {
          arr.push(el);
        }
      });
      this.chooseList = arr;
      if (arr.length == this.cartList.length) {
        this.isCheckedAll = true;
      } else {
        this.isCheckedAll = false;
      }
    },

    //全选反选
    allCheckChange() {
      this.cartList.forEach(el => {
        el.checked = !this.isCheckedAll;
      });
    }
  },
  computed: {
    ...mapState(["cartList"]),
    //计算总价格
    totalPrice() {
      let total = 0 * 100;
      // let isChecked = 0;
      this.cartList.forEach(el => {
        if (el.checked) {
          total += el.totalAmount * 100;
          // isChecked++;
        }
      });
      this.total = total;
      // if(isChecked == this.cartList.length){
      //   this.isCheckedAll = true;
      // }else{
      //   this.isCheckedAll = false;
      // }
      return total;
    }
  }
};
</script>

<style lang="less" scoped>
.navbar {
  width: 100%;
  height: 90px;
}
.cart-list {
  margin-bottom: 100px;
  .list-wrap {
    border-bottom: 1px solid #f2f2f2;
    overflow: hidden;
    padding-top: 30px;
    .checkbox {
      margin-left: 30px;
      display: inline-block;
    }
    .content {
      display: inline-block;
    }
  }
  .product-img {
    width: 150px;
    height: 150px;
    overflow: hidden;
    border: 1px solid #f2f2f2;
    text-align: center;
    margin: 0 27px 0 23px;
    float: left;
    img {
      max-width: 100%;
      max-height: 100%;
      margin: 0 auto;
    }
  }
  .product-wrap {
    display: inline-block;
    font-size: 26px;
    color: #666;
    line-height: 36px;
    width: 430px;
    .brand {
      color: #333;
      font-size: 30px;
      font-weight: bold;
    }
  }
  .price {
    font-size: 26px;
    text-align: right;
    color: #ff6600;
    font-weight: bold;
    padding-right: 30px;
  }
  .product-num {
    float: right;
    margin: 30px;
  }
}
// 底部
.van-submit-bar {
  bottom: 104px;
}
.van-submit-bar__bar {
  height: 90px;
}
.van-submit-bar__button {
  height: 90px;
  width: 180px;
  background: #ff6600;
}
.van-checkbox {
  margin-left: 30px;
}
.van-submit-bar__price {
  color: #ff6600;
}
.van-submit-bar__text span {
  font-size: 28px;
}
// 顶部导航
.van-nav-bar {
  height: 90px;
  line-height: 90px;
}
.van-nav-bar__title {
  font-size: 34px;
}
.van-nav-bar__text {
  font-size: 28px;
  color: #999;
}
.van-nav-bar__arrow {
  font-size: 50px;
  color: #585858;
}
.van-button__text {
  font-size: 24px;
}
// 编辑删除
.delete-wrap {
  width: 100%;
  height: 90px;
  background: #fff;
  position: fixed;
  bottom: 100px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-size: 20px;
  button {
    width: 180px;
    height: 90px;
    border: none;
    color: #fff;
    font-size: 24px;
    background: #f13131;
    position: absolute;
    right: 0;
  }
}
</style>